import React from 'react';

class NoPlayersMessage extends React.Component {
  render() {
    return <div className="alert alert-info">{this.props.message}</div>
  }
}

export default NoPlayersMessage;
